<template>
  <i
    ref="iconElement"
    :class="['zt-icon', 'align-middle leading-none tracking-normal', iconClass]"
  />
</template>

<script>
export default {
  name: 'ztIcon',
  props: {
    name: { type: String, default: '' },
  },
  computed: {
    iconClass() {
      return 'zt-icon-' + this.name
    },
  },
  mounted() {
    const before = window
      .getComputedStyle(this.$refs.iconElement, ':before')
      .getPropertyValue('content')
    if (before === 'none') {
      console.warn('Icon can not be found: ', this.name)
    }
  },
}
</script>

<style scoped src="../../../../styles/components/ztIcon.css" lang="css" />
